import http from "@/common/http.service";
import { getApiBaseUrl } from "@/common/http.header";
const GET_PHONE_CODE_URL = "getPhoneCodes";
const GET_SENDERS_URL = "campaign/get-sender";
const GET_TAGS_URL = "campaign/get-tags";
const HTML_TO_TEXT = "campaign/convert_to_text";
const TRACKING_URL = "campaign/conversion_tracking_codes";
const COUNTRY_URL = "profile/country";
const TIMEZONE_URL = "profile/timezone";
const GET_SCHEDULELE_DATA = "campaign/get-schedule-data";
const GET_TAX_COUNTRY_LIST = "getTaxCountryList";
const GET_REWARD = "getRewardDetails";
export default {
  fetchReward(cb) {
    http.get(GET_REWARD).then(function (response) {
      cb(response.data);
    });
  },
  fetchCountries(cb) {
    http.get(GET_PHONE_CODE_URL, "", getApiBaseUrl()).then(function (response) {
      cb(response.data);
    });
  },
  fetchTaxCountryList(cb) {
    http
      .get(GET_TAX_COUNTRY_LIST, "", getApiBaseUrl())
      .then(function (response) {
        cb(response.data);
      });
  },
  fetchSenderIds(params, cb) {
    http.post(GET_SENDERS_URL, params).then(function (response) {
      var data = {
        senderIds: response.data.sender,
        replayIds: response.data.reply,
        defaultPermRemind: response.data.permRemind,
        allowMultipleSender: response.data.allowMultipleSender,
        allowAmpEmail: response.data.allowAmpEmail,
        verified: response.data.verified,
      };
      cb(data);
    });
  },
  fetchTags(params, cb) {
    http.post(GET_TAGS_URL, params).then(function (response) {
      var data = { tagIds: response.data.tags };
      cb(data);
    });
  },

  fetchTrackingCodes(cb) {
    http.get(TRACKING_URL).then(function (response) {
      cb(response.data);
    });
  },

  convertHtmlToText(params) {
    if (!params.html) {
      return new Promise(function (resolve) {
        resolve({ data: "" });
      });
    }
    params = { ...params };
    params.html = Buffer.from(params.html).toString("base64");
    return http.post(HTML_TO_TEXT, params);
  },

  getDragTemplate(id) {
    return http.post("drag-and-drop/get-template", { id: id });
  },

  saveAsTemplate(data) {
    data = { ...data };
    data.html = Buffer.from(data.html).toString("base64");
    if (data.temp_json) {
      data.temp_json = Buffer.from(data.temp_json).toString("base64");
    }
    return http.post("templates/save", data);
  },

  fetchCurrentTime(id, cb) {
    http.post(GET_SCHEDULELE_DATA, { id }).then(function (response) {
      cb(response.data);
    });
  },

  fetchTimezone(cb) {
    http.get(TIMEZONE_URL).then(function (response) {
      cb(response.data.timezones);
    });
  },

  fetchCountryList(cb) {
    http.get(COUNTRY_URL).then(function (response) {
      cb(response.data);
    });
  },

  getCustomData(url, params = {}) {
    return http.post(url, params);
  },
};
